import React, { Component } from 'react';
import isEmail from 'validator/lib/isEmail'
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputBase from '@material-ui/core/InputBase';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { authHeader, history } from "../../helpers";
import api from '../../constants/api';
import BreadCrumbNav from '../BreadCrumbNav'
import { getUser, checkError,fncisMailAddress,validatePassword} from '../../helpers';
import { postApi } from '../../helpers/http';
import swal from 'sweetalert';
import './AccountNew.css';
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

const kRole = ["一般", "一般管理者", "管理者"];

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid rgb(118, 118, 118)',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

class AccountNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 1000,
      user_name: "",
      user_id: -1,
      tmp_user_id: -1,
      email: "",
      password: "",
      passwordConfirm: "",
      active_flag: 0,
      role: 0,
      openAlert: false,
      editSuccess: false,
      showPassword: false,
      showPasswordConfirm: false
    };
  }

  componentDidMount() {
    const { getTerminals, getSettings } = this.props
    const params = {
      offset: this.state.offset * this.state.limit,
      limit: this.state.limit
    };
    getTerminals(params);

    const paramsUserMaster = {
      offset: 0,
      limit: this.state.limit,
      table_name: "user_master"
    };
    getSettings(paramsUserMaster);
  }

  render() {
    const user = getUser();
    const { usersMaster } = this.props
    // console.log(usersMaster.detailData);

    const sortedUsers = [...(usersMaster.detailData || [])].sort((a, b) =>
         (a.name || "").localeCompare(b.name || "", undefined, {
                               sensitivity: "base",
                               numeric: true
                              })
                           );
                           
    const changeUserMaster = (event) => {
      const { value } = event.target;
      const selectedUser = usersMaster.detailData.find(user => user.i_num === Number(value));

      this.setState({
        tmp_user_id: selectedUser?.i_num || "",
        user_id: selectedUser?.i_num || "",
        user_name: selectedUser?.name || "",
        department_name: selectedUser?.department_name || "",
        section_name: selectedUser?.section_name || "",
      });
    };

    const changeEmail = (event) => {
      const {value} = event.target;
      this.setState({email: value});
    };
    
    const changePassword = (event) => {
      const {value} = event.target;
      this.setState({
        password: value
      });
    };

    const changePasswordConfirm = (event) => {
      const {value} = event.target;
      this.setState({
        passwordConfirm: value
      });
    };

    const changeRole = (event) => {
      const { value } = event.target;
      this.setState({ role: Number(value) });
    };

    const changeActiveFlag = (event) => {
      const {value} = event.target;
      this.setState({ active_flag: Number(value) });
    };

    const validateUserInput = (user_id, email, password, passwordConfirm) => {
      if (user_id === -1 || user_id === "") {
        swal({
            title: "設定エラー！",
            text: "名前を設定してください。",
            icon: "warning",
            buttons: "はい"
        });
        return false;
      }

      if (email.trim() === "") {
        swal({
            title: "設定エラー！",
            text: "メールアドレスを確認してください。",
            icon: "warning",
            buttons: "はい"
        });
        return false;
      }

      if (!fncisMailAddress(email)) {
        return false;
      }

      if (!password) {
            swal({
               title: "設定エラー！",
               text: "新しいパスワードを入力してください。",
               icon: "warning",
               button: "はい",
            });
            return false;
         }

         if (!passwordConfirm) {
            swal({
               title: "設定エラー！",
               text: "新しいパスワード(確認用)を入力してください。",
               icon: "warning",
               button: "はい",
            });
            return false;
         }

         if (password !== passwordConfirm) {
            swal({
               title: "設定エラー！",
               text: "「新しいパスワード」に入力した値が「新しいパスワード（確認用）」に入力した値と一致しません。",
               icon: "warning",
               button: "はい",
            });            
            return false;
         }

         if (!validatePassword(password)) {
            return false;
         }

      return true; 
    };

    const handleOnBlur = (event) => {
       if (this.state.tmp_user_id == "") {
          this.setState({
            user_id: "",
            user_name: ""
          });
       };
    };

    const handleEdit = async (event) => {
      const { user_id , email ,password, passwordConfirm } = this.state;

      if (!validateUserInput(user_id , email ,password, passwordConfirm)) {
        return;  
      }

      const isExist = await checkExistAccount(email);
      
      let message_title = "";
      let message_text = "";

      
      if (isExist === false) {
          message_title = "登録しますか？";
          message_text = ""
      } else {
          message_title = "";
          message_text = email + "が既に存在しました。このアカウントの情報を更新しますか？"
      };

      console.log("message_title:", message_title);

      swal({
        title: message_title,
        text: message_text,
        icon: "warning",
        buttons: ["いいえ", "はい"],
        dangerMode: true,
      })

      .then(async(confirm) => {
            if (confirm) {
              const data = {
                "process_type": "insertUserAccount",
                "table_name": "user_tb",
                "user_id": Number(this.state.user_id),
                "role": Number(this.state.role),
                "login_email": this.state.email.toLowerCase(),
                "password": this.state.password,
                "user_name": this.state.user_name,
                "department_name": this.state.department_name,
                "pc_name": this.state.pc_name,
                "login_ip": this.state.login_ip,
                "active_flag": Number(this.state.active_flag),
                "create_time": this.state.create_time,
                "update_time": this.state.update_time,
              };

              try {
                const json = await postApi(data);
                if (json.statusCode == 200) {
                    swal({
                          title: "登録しました。",
                          icon: "success",
                          buttons: "はい"
                    }).then(() => {
                      history.push("/index.html?p=accounts");
                    });
                } else {
                    swal({
                    title: "設定エラー！",
                    text:  json.data || "登録に失敗しました。",
                    icon: "warning",
                    button: "はい",
                    });
                };

              } catch (error) {
                swal({
                   title: "設定エラー！",
                   text:  "登録に失敗しました。",
                   icon: "warning",
                   button: "はい",
                });

              };
            } else {
               swal.stopLoading();
               swal.close();
            }
            })
         .catch((err) => {
            if (err) {
               swal({
                  title: "エラー！",
                  text:  "予期しないエラーが発生しました。",
                  icon: "error",
                  buttons: "はい"
               });
            }
         });
      };

    const handleExit = (event) => {
       history.push("/index.html?p=accounts");
    };

    const handleCloseSuccess = () => {
      this.setState({openAlert: false,});
    };

    const toggleShowPassword = () => {
      this.setState({
        showPassword: !this.state.showPassword
      });
    };

    const toggleShowPasswordConfirm = () => {
      this.setState({
        showPasswordConfirm: !this.state.showPasswordConfirm
      });
    };

    const checkExistAccount = async (email) => {
      const data = {
        "process_type": "getUserAccount",
        "login_email": email,
      };

      const json = await postApi(data);

      if (json.data.detailData.length === 0) {
          return false;
      } else {
        return true;
      };

      return false;

    };

    return (
      <div className="content-container">
        <BreadCrumbNav screenName="アカウント登録" prevLinks={[{url:'/index.html?p=accounts', text: 'アカウント情報編集'}]}></BreadCrumbNav>
        <div className="loginname">ログイン名：{user.username}</div>
        <h1 className="accountnew__heading">アカウント登録</h1>
        
        <div className="accountnew-form">
          <div className="accountnew-form__group-item">
            <div className="accountnew-form__item-title"><span>名前</span></div>
            <Autocomplete
              freeSolo
              className="accountnew-form__item-value"
              options={sortedUsers || []}
              getOptionLabel={(option) => option?.name || ""}
              value={
                usersMaster.detailData?.find(
                  u => u.i_num === this.state.user_id
                ) || null
              }
              inputValue={this.state.user_name}
              onChange={(event, newValue) => {
                changeUserMaster({
                  target: {
                    value: newValue ? newValue.i_num : ""
                  }
                });
              }}
              onInputChange={(event, newInputValue) => {
                  this.setState({
                      user_name: newInputValue,
                      tmp_user_id: ""
                  });
              }}
              isOptionEqualToValue={(option, value) => option.i_num === value.i_num}
              clearOnEscape
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="autocomplete-filter"
                  variant="outlined"
                  onBlur={handleOnBlur}
                />
              )}
            />
          </div>

          <div className="accountnew-form__group-item">
            <div className="accountnew-form__item-title"><span>部</span></div>
            <NativeSelect className="accountnew-form__item-value"
              id="demo-customized-select-native"
              value={this.state.user_id}
              input={<BootstrapInput />}
              disabled={true}
            >
              <option aria-label="無し" value="" />
              {usersMaster.detailData && (usersMaster.detailData).map((userMaster, index) => (
                <option value={userMaster.i_num} key={index}>{userMaster.section_name}</option>
              ))}
            </NativeSelect>
          </div>

          <div className="accountnew-form__group-item">
            <div className="accountnew-form__item-title"><span>課</span></div>
            <NativeSelect className="accountnew-form__item-value"
              id="demo-customized-select-native"
              value={this.state.user_id}
              input={<BootstrapInput />}
              disabled={true}
            >
              <option aria-label="無し" value="" />
              {usersMaster.detailData && (usersMaster.detailData).map((userMaster, index) => (
                <option value={userMaster.i_num} key={index}>{userMaster.department_name}</option>
              ))}
            </NativeSelect>
          </div>

          <div className="accountnew-form__group-item">
            <div className="accountnew-form__item-title"><span>権限</span></div>
            <NativeSelect className="accountnew-form__item-value"
              id="demo-customized-select-native"
              value={this.state.role}
              onChange={changeRole}
              input={<BootstrapInput />}
            >
              {(user.role >= "0") && <option value={"0"}>{kRole[0]}</option>}
              {(user.role >= "1") && <option value={"1"}>{kRole[1]}</option>}
              {(user.role >= "2") && <option value={"2"}>{kRole[2]}</option>}
            </NativeSelect>
          </div>

          <div className="accountnew-form__group-item">
            <div className="accountnew-form__item-title"><span>メールアドレス</span></div>
            {/* <input type="text" name="" id="manufacturer" className="accountnew-form__item-value"/> */}
            <TextField variant="outlined" className="accountnew-form__item-value"
                value={this.state.email} 
                onChange={changeEmail}/>
          </div>

          <div className="accountnew-form__group-item">
            <div className="accountnew-form__item-title"><span>パスワード</span></div>
            <TextField variant="outlined" className="accountnew-form__item-value"
                value={this.state.password} 
                onChange={changePassword}
                type={this.state.showPassword ? "text" : "password"}
                autoComplete="new-password"
                InputProps={{
                  endAdornment: (
                    <span
                      onClick={toggleShowPassword}
                      style={{
                        cursor: "pointer",
                        color: "gray",
                        fontSize: "24px",
                        userSelect: "none",
                        paddingRight: "4px"
                      }}
                    >
                      {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                    </span>
                  )
                }}
            />
          </div>

          <div className="accountnew-form__group-item">
            <div className="accountnew-form__item-title"><span>パスワード(確認用)</span></div>
            <TextField variant="outlined" className="accountnew-form__item-value"
                value={this.state.passwordConfirm} 
                onChange={changePasswordConfirm}
                type={this.state.showPasswordConfirm ? "text" : "password"}
                autoComplete="new-password"
                InputProps={{
                  endAdornment: (
                    <span
                      onClick={toggleShowPasswordConfirm}
                      style={{
                        cursor: "pointer",
                        color: "gray",
                        fontSize: "24px",
                        userSelect: "none",
                        paddingRight: "4px"
                      }}
                    >
                      {this.state.showPasswordConfirm ? <Visibility /> : <VisibilityOff />}
                    </span>
                  )
                }}
            />
          </div>

          <div className="accountedit-form__group-item">
            <div className="accountedit-form__item-title"><span>アカウント</span></div>
            <NativeSelect className="accountnew-form__item-active-flag"
              id="demo-customized-select-native"
              value={this.state.active_flag}
              onChange={changeActiveFlag}
              input={<BootstrapInput />}
            >
              <option value={"0"}>有効</option>
              <option value={"1"}>無効</option>
            </NativeSelect>
          </div>

          <div className="accountnew-form__controls">
            <button className="accountnew-btn" onClick={handleEdit}>登録</button>
            <button className="accountexit-btn" onClick={handleExit}>戻る</button>
          </div>
        </div>

        <Snackbar open={this.state.openAlert} autoHideDuration={6000} onClose={handleCloseSuccess}>
          <Alert onClose={handleCloseSuccess} severity={this.state.editSuccess ? "success" : "error"}>
            {this.state.editSuccess ? "登録しました。" : "登録に失敗しました。"}
          </Alert>
        </Snackbar>
      </div>
    );
  }
}

AccountNew.propTypes = {
  getTerminals: PropTypes.func.isRequired,
};

export default AccountNew;